import React, { useEffect, useState } from 'react';
import classes from '@components/Fireboard/components/Body/TileView/ChecksCard/checksCard.module.scss';
import cn from 'classnames';
import { useOutletContext } from 'react-router-dom';
import CardContentByMode from '@components/Fireboard/components/Body/TileView/ChecksCard/modeTileContent';

const MODE_BUTTONS = {
  DEFAULT: [
    { label: 'Notify', action: 'notifyGuest', type: 'handler' },
    { label: 'Dynamic', type: 'statusUpdate' },
  ],
  ON_PREMISE: [
    { label: 'Print', action: 'print', type: 'handler' },
    { label: 'Receipt', action: 'receipt', type: 'handler' },
  ],
  OFF_PREMISE: [
    { label: 'Notify', action: 'notifyGuest', type: 'handler' },
    { label: 'Dynamic', type: 'statusUpdate' },
  ],
  TABLE_DELIVERY: [
    { label: 'Notify', action: 'notifyGuest', type: 'handler' },
    { label: 'Dynamic', type: 'statusUpdate' },
  ],
  OFF_PREMISE_VENUE: [
    { label: 'Notify', action: 'notifyGuest', type: 'handler' },
    { label: 'Dynamic', type: 'statusUpdate' },
  ],
};

const GroupedChecksCardContent = ({ check, currentMode }) => {
  const {
    handleExpandedRightSection,
    updateOrderStatus,
    setSelectedCheck,
    selectedCheck,
  } = useOutletContext();
  const isSelected = selectedCheck === check.id;
  const handlers = { handleExpandedRightSection, updateOrderStatus };
  const footerButtons = MODE_BUTTONS[currentMode] || MODE_BUTTONS.DEFAULT;
  const [buttonState, setButtonState] = useState('complete');
  const isStatus = currentMode !== 'ON_PREMISE';
  const isChannel =
    currentMode !== 'ON_PREMISE' && currentMode !== 'TABLE_DELIVERY';

  useEffect(() => {
    const status = check?.status?.status?.toLowerCase();
    if (status === 'complete') {
      setButtonState('pickedUp');
    } else if (status === 'picked up') {
      setButtonState('disabled');
    } else if (status === 'pending') {
      setButtonState('inProgress');
    }
  }, [check?.status?.status]);

  const getButtonLabel = label => {
    if (label !== 'Dynamic') return label;
    if (buttonState === 'inProgress') return 'Progress';
    if (buttonState === 'complete') return 'Complete';
    if (buttonState === 'pickedUp' || buttonState === 'disabled')
      return 'Picked Up';
    return 'Complete';
  };

  const handleClick = btn => {
    if (btn.type === 'handler') {
      handlers.handleExpandedRightSection(btn.action);
    } else if (btn.type === 'statusUpdate') {
      if (buttonState === 'complete') {
        updateOrderStatus(check, 'complete');
        setButtonState('pickedUp');
      } else if (buttonState === 'pickedUp') {
        updateOrderStatus(check, 'pickedUp');
        setButtonState('disabled');
      } else if (buttonState === 'inProgress') {
        updateOrderStatus(check, 'inProgress');
        setButtonState('complete');
      }
    }
  };

  return (
    <div
      className={cn(
        classes.cardContainer,
        'col-12 p-0',
        isSelected && classes.selecteditem
      )}
      onClick={() => setSelectedCheck(check?.id)}
    >
      <div
        className={cn(
          classes.TileHeader,
          'd-flex align-items-center justify-content-between'
        )}
      >
        {isChannel && <div className={classes.channelIcon}>{check?.mode}</div>}
        <div
          className={cn(
            'd-flex px-1 text-truncate',
            currentMode === 'ON_PREMISE' ? 'col-12' : 'col-5',
            currentMode === 'TABLE_DELIVERY'
              ? 'text-left'
              : 'text-center justify-content-center'
          )}
        >
          <div className={cn('text-truncate col px-0')}>
            {check?.tabName || check?.orderDetails?.orderName || '---'}
          </div>
        </div>
        {isStatus && (
          <div
            className={cn('rounded-pill fw-400 text-right', classes.statusPill)}
            style={{
              backgroundColor: check?.status?.color,
              border: check?.status?.border,
            }}
          >
            {check.status?.status}
          </div>
        )}
      </div>

      <CardContentByMode check={check} mode={currentMode} />

      <div className="col-12 px-1 d-flex gap-2 pb-2 mt-auto">
        {footerButtons.map(btn => {
          const isDisabled =
            buttonState === 'disabled' && btn.type === 'statusUpdate';
          return (
            <div className="col-6 px-1">
              <button
                className={cn(
                  classes.primaryBtn,
                  'col-12 px-1 fw-500',
                  isDisabled && classes.disabledbtn
                )}
                disabled={isDisabled}
                onClick={() => handleClick(btn)}
              >
                {getButtonLabel(btn.label)}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GroupedChecksCardContent;
